export default __webpack_public_path__ + "static/media/new_logo.3f00d261.png";